<template>
  <div class="horizontal-list">
    <div
      v-if="previousElementOffset >= 0"
      class="horizontal-list__left btn"
      @click="scrollLeft"
    />

    <div
      ref="template-list"
      class="horizontal-list__center template-list-center"
    >
      <div
        ref="template-list-track"
        class="template-list-center__track"
      >
        <slot name="items" />
      </div>
    </div>

    <div
      v-if="nextElementOffset < length"
      class="horizontal-list__right btn"
      @click="scrollRight"
    />
  </div>
</template>

<script>
export default {
  props: {
    length: { type: Number, default: 0 },
    childTarget: { type: String, default: 'div' },
  },
  data() {
    return {
      visibleElements: [],
      previousElementOffset: -1,
      nextElementOffset: 10000,
      templateObserver: null,
    };
  },
  watch: {
    length() {
      setTimeout(() => {
        this.observeTemplates();
      }, 100);
    },
  },
  mounted() {
    this.observeTemplates();
  },
  methods: {
    observeTemplates() {
      if (this.templateObserver) {
        this.templateObserver.disconnect();
      }
      const scrollViewElement = this.$refs['template-list'];
      this.templateObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const offset = Number(entry.target.dataset.offset);
            if (entry.intersectionRatio === 1) {
              this.visibleElements.push(offset);
            } else {
              this.visibleElements = this.visibleElements.filter(
                (item) => item !== offset,
              );
            }
          });
          this.previousElementOffset = Math.min(...this.visibleElements) - 1;
          this.nextElementOffset = Math.max(...this.visibleElements) + 1;
        },
        {
          root: scrollViewElement,
          rootMargin: '0px 5px 0px 0px',
          threshold: 1.0,
        },
      );

      this.$refs['template-list-track']
        .querySelectorAll(this.childTarget)
        .forEach((element) => {
          this.templateObserver.observe(element);
        });
    },
    scrollLeft() {
      this.scroll(`${this.childTarget}[data-offset="${this.previousElementOffset}"]`);
    },
    scrollRight() {
      this.scroll(`${this.childTarget}[data-offset="${this.nextElementOffset}"]`);
    },
    scroll(selector) {
      const element = this.$refs['template-list-track'].querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'center',
        });
      }
    },
  },
};
</script>
